<div class="cads-stack-bit" role="group">
  <ng-content />
</div>
